module.exports = __webpack_public_path__ + "img/5.620b4102.jpg";